export default __webpack_public_path__ + "static/media/img-0410-austria-half-face.88810fcd.png";